import axios      from 'axios'
import { config } from '@/config';
import { CpqCartProductJson } from './cpq-builder/cpq-json.interface';
import { getLocalOrDefaultLang } from '../store/util';

export class SaleSquezeSdkBrowser {

  clientKey = config.clientKey;

  viewToken: string | undefined;

  editToken: string | undefined;

  apiBaseUrl = '/api/v3';

  constructor() {
    console.log(`%c======== SaleSqueze SDK initialized ========
Language : ${ getLocalOrDefaultLang() }
Client   : ${ this.clientKey }
API      : ${ this.apiBaseUrl }
============================================`, this.clientKey ? 'color:green' : 'color:red')
  }

  /**
   * @param {string} documentServiceType
   * @return {Promise<any>}
   */
  createDocument(documentServiceType: string, document: any) {
    return axios.post(`${ this.apiBaseUrl }/dynamic-form/${ documentServiceType }/documents`, document, {
      headers: {
        'X-Client-Key': this.clientKey,
        'viewToken': this.viewToken,
        'editToken': this.editToken,
        'Accept-Language': getLocalOrDefaultLang(),
      }
    })
  }

  /**
   * @param {string} documentId
   * @param {string} documentServiceType
   * @return {Promise<any>}
   */
  reviseDocument(documentId: string, editToken: string, documentServiceType: string, document: any) {
    return axios.post(`${ this.apiBaseUrl }/dynamic-form/${ documentServiceType }/documents/${ documentId }/revisions`, document, {
      headers: {
        'X-Client-Key': this.clientKey,
        'viewToken': this.viewToken,
        'editToken': editToken,
        'x-share-edit': editToken,
        'Accept-Language': getLocalOrDefaultLang(),
      }
    })
  }

  /**
   * @param {string[]} tags Tags to filter by.
   * @return {Promise<any>}
   */
  getProducts(filter: { tags?: string[], categories?: string[], key?: string }, project?: { [x: string]: number }) {
    return axios.get(`${ this.apiBaseUrl }/catalog/product/cpq/documents`, {
      headers: {
        'X-Client-Key': this.clientKey,
        'viewToken': this.viewToken,
        'editToken': this.editToken,
        'Accept-Language': getLocalOrDefaultLang(),
      },
      params: {
        pageSize: 999,
        sortBy: {
          path: '_createdAt',
          direction: -1
        },
        filter: {
          ...(filter.tags ? {
            tags: {
              type: 'type-string',
              value: filter.tags,
              options: {
                exactMatch: true,
                exclude: false,
              }
            }
          } : {}),
          ...(filter.categories ? {
            categoryKey: {
              type: 'type-string',
              value: filter.categories,
              options: {
                exactMatch: true,
                exclude: false,
              }
            }
          } : {}),
          ...(filter.key ? {
            key: {
              type: 'type-string',
              value: filter.key,
              options: {
                exactMatch: true,
                exclude: false,
              }
            }
          } : {}),
        },
        project: {
          configurableAddons: 1,
          propertyAttributes: 1,
          ...project
        }
      }
    }).then(res => {
      if (res.data.items) {
        res.data.items = res.data.items.map((item: any) => {
          item.catalogKey = item.key;
          if (item.metadata?.thumbnail) {
            item.metadata.thumbnail = item.metadata.thumbnail.replace('https://salesqueze-production-fs.s3.eu-central-1.amazonaws.com/vez-sedezi/assets/', 'https://vez-sedezi.salesqueze.com/storage/assets/');
          }
          return item;
        })
      }
      return res;
    })
  }

  evaluateCart(body: { products: CpqCartProductJson[] }) {
    body.products = body.products.map((product) => {
      product.catalogKey = product.key;
      return product;
    })

    return axios.post(`${ this.apiBaseUrl }/catalog/cpq/product-lines`, body, {
      headers: {
        'X-Client-Key': this.clientKey,
        'viewToken': this.viewToken,
        'editToken': this.editToken,
        'Accept-Language': getLocalOrDefaultLang(),
      },
    })
  }

  getPartnerInfo(partnerKey: string) {
    return axios.get(`${this.apiBaseUrl }/clients/experience/info/partner/${partnerKey}`, {
      headers: {
        'X-Client-Key': this.clientKey,
        'viewToken': this.viewToken,
        'editToken': this.editToken,
        'Accept-Language': getLocalOrDefaultLang(),
      },
    })
  }

  getOrder(documentId: string, editToken: string) {
    return axios.get(`${this.apiBaseUrl }/dynamic-form/cpq/documents/${documentId}`, {
      headers: {
        'X-Client-Key': this.clientKey,
        'viewToken': this.viewToken,
        'editToken': this.editToken,
        'x-share-edit': editToken,
      },
    })
  }
}

export const salesqueze = new SaleSquezeSdkBrowser()
